<!--华普定制单位概况-->
<template>
	<div class="hpBody">
		<!--头部-->
		<hpTitle></hpTitle>
		<!--中间-->
		<div class="hpIntermediate" v-bind:style="backImg">
			<basicInformation></basicInformation>
			<div class="transformeMap" :style="getBackImg('huapu/map.png')">
				<transformerMap></transformerMap>
			</div>
			<div style="width: 35%;height: 100%;">
				<hpEvent></hpEvent>
			</div>
		</div>
		<!--底部-->
		<div class="hpBottom" v-bind:style="backImg">
			<div style="width: 40%;height: 100%;">
				<realTimeLoad></realTimeLoad>
			</div>
			<div style="width:60%;height: 100%;">
				<hpElectricity></hpElectricity>
			</div>
		</div>
	</div>
</template>
<script>
	import hpTitle from '@/page/projectDingZhi/huapu/huapuGas/hpTitle.vue'
	import basicInformation from '@/page/projectDingZhi/huapu/huapuGas/basicInformation.vue'
	import transformerMap from '@/page/projectDingZhi/huapu/huapuGas/transformerMap.vue'
	import hpEvent from '@/page/projectDingZhi/huapu/huapuGas//hpEvent.vue'
	import hpElectricity from '@/page/projectDingZhi/huapu/huapuGas/hpElectricity.vue'
	import realTimeLoad from '@/page/projectDingZhi/huapu/huapuGas/realTimeLoad.vue'
	import resourcesStore from '@/cache/resourcesStore.js'
	import archivesStore from '@/cache/archivesStore.js'
	export default {
		components: {
			hpTitle,
			basicInformation,
			archivesStore,
			transformerMap,
			hpEvent,
			realTimeLoad,
			hpElectricity,
		},
		props: {},
		data() {
			return {}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {
			imgName() {
				return resourcesStore.getters.getResourcesByName
			},
			backImg() {
				return {
					'background-image': 'url(' + this.imgName('huapu/background.png') + ')'
				}
			},
			getBackImg() {
				return back => {
					return {
						'background-image': 'url(' + this.imgName(back) + ')'
					}
				}
			},
			getArchivesTree() {
				return archivesStore.getters.getReadDeviceGroupTree()
			}
		},
		watch: {},
		methods: {}
	}
</script>

<style scoped>
	.hpBody {
		width: 100%;
		overflow: hidden;
		background-color: #14345d;
	}
	
	.hpIntermediate {
		width: 100%;
		height: 50%;
		background-size: 20%;
		display: flex;
		align-items: center;
	}
	
	.hpBottom {
		width: 100%;
		height: 42%;
		background-size: 20%;
		display: flex;
		align-items: center;
	}
	
	.transformeMap {
		width: 35%;
		height: 100%;
		background-size: 100% 100%;
		background-repeat: no-repeat;
		display: flex;
		align-content: center;
		justify-content: center;
	}
</style>